import { Box, Tab, Tabs } from "@material-ui/core";
import {
    Championship,
    Collections,
    Round,
    Track,
    useCollection,
    useThemeBreakpoints,
} from "api";
import { DateTime } from "luxon";
import React, { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router";
import { PageLayout } from "ui/componentes";
import { IncidentsReportTable } from "ui/views";

const selectRoundTab = (setSelectedRound) => (event, value) => {
    setSelectedRound(value);
};

const IncidentsReportView = () => {
    const { championshipId } = useParams<{ championshipId }>();
    const [selectedRound, setSelectedRound] = useState("-1");

    const tracksById =
        useCollection<{ [key: string]: Track }>({
            collection: Collections.TRACKS,
        }) || {};

    const championship =
        useCollection<Championship>({
            collection: Collections.CHAMPIONSHIPS,
            doc: championshipId,
            storeAs: `champToreport${championshipId}`,
        }) || {};
    const rounds =
        useCollection<Round[]>(
            {
                collection: Collections.ROUNDS,
                where: ["championshipId", "==", championshipId],
                storeAs: `roundsToReport${championshipId}`,
            },
            true
        ) || [];
    rounds.sort(
        (r1, r2) =>
            DateTime.fromISO(r1.date).toMillis() -
            DateTime.fromISO(r2.date).toMillis()
    );

    const { isDownMd } = useThemeBreakpoints();

    const roundsById = useMemo(() => {
        const roundsById = {};
        rounds.forEach((round) => (roundsById[round.id || ""] = round));
        return roundsById;
    }, [rounds]);

    useEffect(() => {
        const roundIds = rounds.map((round) => round.id);
        const today = DateTime.local().toFormat("yyyy-MM-dd");

        if (!selectedRound || !roundIds.includes(selectedRound)) {
            const roundsBeforeEqualToday = rounds
                .filter((round) => round.date <= today)
                .sort(
                    (r1, r2) =>
                        DateTime.fromISO(r2.date).toMillis() -
                        DateTime.fromISO(r1.date).toMillis()
                );
            if (roundsBeforeEqualToday.length > 0) {
                setSelectedRound(roundsBeforeEqualToday[0].id || "");
            } else {
                setSelectedRound(rounds[0] ? rounds[0].id || "" : "");
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rounds]);

    return (
        <PageLayout
            title={`Relatório de incidentes - ${championship.name}`}
            showInBoxCard={false}
            boxCardProps={{
                display: "flex",
                flexDirection: "column",
            }}
        >
            <Box>
                <Tabs
                    variant={isDownMd ? "scrollable" : "fullWidth"}
                    centered={!isDownMd}
                    indicatorColor="primary"
                    textColor="primary"
                    scrollButtons="on"
                    value={selectedRound}
                    onChange={selectRoundTab(setSelectedRound)}
                >
                    {rounds.map(({ id, trackId, date }) => {
                        const track = tracksById[trackId];
                        const tabName = `${
                            track?.friendlyName
                        } - ${DateTime.fromFormat(date, "yyyy-MM-dd").toFormat(
                            "dd/MM/yyyy"
                        )}`;
                        return (
                            <Tab
                                key={`round_${id}`}
                                label={tabName}
                                value={id}
                                style={{ fontSize: "0.85rem" }}
                            />
                        );
                    })}
                </Tabs>
            </Box>
            <Box marginTop={1} flexGrow={1}>
                <IncidentsReportTable
                    roundId={selectedRound}
                    round={roundsById[selectedRound]}
                    championship={{ ...championship, id: championshipId }}
                />
            </Box>
        </PageLayout>
    );
};

export { IncidentsReportView };
